document.addEventListener('DOMContentLoaded', function () {
  var bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;

  var buttonId = bar.getAttribute('data-target-button');
  var priceId = bar.getAttribute('data-target-price');
  var mainButton = buttonId ? document.getElementById(buttonId) : null;
  var priceContainer = priceId ? document.getElementById(priceId) : null;
  var stickyButton = bar.querySelector('[data-sticky-atc-button]');
  var stickyPrice = bar.querySelector('[data-sticky-atc-price]');

  if (!mainButton || !stickyButton) return;

  var stickyDefaultLabel = stickyButton.textContent.trim();

  function syncButtonState() {
    var isDisabled = mainButton.disabled;
    stickyButton.disabled = isDisabled;
    if (isDisabled) {
      var label = mainButton.querySelector('span');
      if (label && label.textContent.trim()) {
        stickyButton.textContent = label.textContent.trim();
      }
    } else if (stickyButton.textContent.trim() !== stickyDefaultLabel) {
      stickyButton.textContent = stickyDefaultLabel;
    }
  }

  function syncPrice() {
    if (!priceContainer || !stickyPrice) return;
    var priceItem = priceContainer.querySelector('.price-item--regular, .price-item--sale, .price__regular .price-item, .price__sale .price-item');
    if (priceItem) {
      stickyPrice.textContent = priceItem.textContent.trim();
    } else {
      var text = priceContainer.textContent.trim();
      stickyPrice.textContent = text.split('\n')[0].trim();
    }
  }

  syncButtonState();
  syncPrice();

  var buttonObserver = new MutationObserver(syncButtonState);
  buttonObserver.observe(mainButton, { attributes: true, childList: true, subtree: true });

  if (priceContainer) {
    var priceObserver = new MutationObserver(syncPrice);
    priceObserver.observe(priceContainer, { childList: true, subtree: true, characterData: true });
  }

  stickyButton.addEventListener('click', function () {
    if (!mainButton.disabled) {
      mainButton.click();
    }
  });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bar.classList.remove('is-visible');
          } else if (entry.boundingClientRect.top < 0) {
            bar.classList.add('is-visible');
          } else {
            bar.classList.remove('is-visible');
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(mainButton);
  } else {
    bar.classList.add('is-visible');
  }
});
